import { useMemo } from 'react';
import { useCompanySuggestions } from "@components/AddNewEntity/hooks/useCompanySuggestions";
import { useCompanyOptions } from './useCompanyOptions';

export function useCompanyAndSuggestionOptions() {
  const {
    searchedOptions: companyOptions,
    hasNextPage,
    debouncedSearch,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    searchQuery,
    defaultOptions,
    setSearchQuery,
  } = useCompanyOptions();

  const { data: suggestionOptions, isLoading: isLoadingSuggestions } = useCompanySuggestions(searchQuery);

  const groupedOptions = useMemo(() => {
    if (!searchQuery) return [{ label: 'Companies in Meridian', options: companyOptions }];
    if (!suggestionOptions || suggestionOptions.length === 0) return companyOptions;
    return [
      { label: 'Companies in Meridian', options: companyOptions },
      {
        label: 'Suggestions from global database ',
        options: suggestionOptions.map((s) => ({
          data: { ...s },
          logo_url: s.logo,
          website: s.website,
          suggested: true,
          label: s.name,
          value: s.id,
        })),
      },
    ];
  }, [companyOptions, suggestionOptions, searchQuery]);

  return {
    groupedOptions,
    hasNextPage,
    debouncedSearch,
    isLoading: isLoading || isLoadingSuggestions,
    isFetchingNextPage,
    fetchNextPage,
    searchQuery,
    setSearchQuery,
    defaultOptions,
  };
}
